const GET_MONITORING_TYPES = `
  query LogicmonitorMonitoringTypes {
    logicmonitorMonitoringTypes {
      id
      monitoringType
      connectionType
      collectorType
      serviceUrlPropertyName
      credentialIds
      logicmonitorSystemCategories {
        id
        category
      }
    }
  }
`

const CREATE_MONITORING_TYPE = `
  mutation CreateLogicmonitorMonitoringType(
    $monitoringType: String
    $connectionType: String
    $collectorType: String
    $serviceUrlPropertyName: String
    $credentialIds: [ID!]
    $logicmonitorSystemCategories: [LogicmonitorSystemCategoryInput!]
  ) {
    createLogicmonitorMonitoringType(input: {
      monitoringType: $monitoringType
      connectionType: $connectionType
      collectorType: $collectorType
      serviceUrlPropertyName: $serviceUrlPropertyName
      credentialIds: $credentialIds
      logicmonitorSystemCategories: $logicmonitorSystemCategories
    }){
      errors
    }
  }
`

const DESTROY_MONITORING_TYPE = `
  mutation DestroyLogicmonitorMonitoringType(
    $id: ID!
  ) {
    destroyLogicmonitorMonitoringType(input: {
      id: $id
		}){
			errors
		}
  }
`

const GET_CREDENTIAL_COMPONENTS = `
  query CredentialComponents(
    $serviceName: [String!]
  ) {
    credentialComponents(serviceName: $serviceName) {
      id
      credentialType
      value
    }
  }
`

const CREATE_CREDENTIAL_COMPONENT = `
  mutation CreateCredentialComponent(
    $serviceName: String
    $credentialType: String
    $value: String
  ) {
    createCredentialComponent(input: {
      serviceName: $serviceName,
      credentialType: $credentialType,
      value: $value
    }){
      errors  
    }
  }
`

const UPDATE_MONITORING_TYPE = `
  mutation UpdateLogicmonitorMonitoringType(
    $id: ID!
    $monitoringType: String
    $connectionType: String
    $collectorType: String
    $serviceUrlPropertyName: String
    $credentialIds: [ID!]
    $logicmonitorSystemCategories: [LogicmonitorSystemCategoryInput!]
  ) {
    updateLogicmonitorMonitoringType(input: {
      id: $id
      monitoringType: $monitoringType
      connectionType: $connectionType
      collectorType: $collectorType
      serviceUrlPropertyName: $serviceUrlPropertyName
      credentialIds: $credentialIds
      logicmonitorSystemCategories: $logicmonitorSystemCategories
    }){
      errors
    }
  }
`
const GET_LOGICMONITOR_SYSTEM_CATEGORIES = `
  query LogicmonitorSystemCategories {
    logicmonitorSystemCategories {
      id
      logicmonitorMonitoringTypeId
      category
      createdAt
      deletedAt
    }
  }
`

export {
  CREATE_CREDENTIAL_COMPONENT,
  CREATE_MONITORING_TYPE,
  DESTROY_MONITORING_TYPE,
  GET_CREDENTIAL_COMPONENTS,
  GET_LOGICMONITOR_SYSTEM_CATEGORIES,
  GET_MONITORING_TYPES,
  UPDATE_MONITORING_TYPE
}
